import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../Services/user.service';

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);
  if (userService.checkRole() === 'Admin') {
    return true;
  }
  router.navigate(['/unauthorized']);
  return false;
};
